// extracted by mini-css-extract-plugin
module.exports =  {"container":"e3afc254ff--container--dFUie","star":"e3afc254ff--star--vIS8m","active":"e3afc254ff--active--qC5E8","hover":"e3afc254ff--hover--lWDZb"};